module.exports = __webpack_public_path__ + "media/images/athletes/932-6226372c8da0d3d9c478b295582e0b9d.png";